document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.reviews-showcase').forEach(function (root) {
    initReviewsShowcaseVideoCarousel(root);
    initReviewsShowcaseTabs(root);
  });
});

function initReviewsShowcaseVideoCarousel(root) {
  let currentPlaying = null;

  root.querySelectorAll('.reviews-showcase__video-frame').forEach(function (frame) {
    frame.addEventListener('click', function () {
      const video = document.getElementById(frame.getAttribute('data-video-target'));
      if (!video) return;

      if (currentPlaying && currentPlaying !== video) {
        currentPlaying.pause();
        currentPlaying.currentTime = 0;
        currentPlaying.closest('.reviews-showcase__video-item').classList.remove('is-playing');
      }

      frame.closest('.reviews-showcase__video-item').classList.add('is-playing');
      video.play();
      currentPlaying = video;
    });
  });

  root.querySelectorAll('.reviews-showcase__video-player').forEach(function (video) {
    video.addEventListener('ended', function () {
      video.closest('.reviews-showcase__video-item').classList.remove('is-playing');
      video.currentTime = 0;
      currentPlaying = null;
    });
  });
}

function initReviewsShowcaseTabs(root) {
  const tabs = root.querySelectorAll('.reviews-showcase__tab');
  const cards = root.querySelectorAll('.reviews-showcase__card');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');

      const category = tab.getAttribute('data-category');
      cards.forEach(function (card) {
        card.classList.toggle('is-visible', card.getAttribute('data-category') === category);
      });
    });
  });
}
